import { format } from '@shared/wrappers/date/date';

const DATE_FORMAT_DATE_PICKER = 'MMM DD, YYYY';

export const formatDateValueToInput = ({ endDate, startDate, separator = '⟶' }) => {
    const formattedStartDate = format(startDate, DATE_FORMAT_DATE_PICKER);
    const formattedEndDate = format(endDate, DATE_FORMAT_DATE_PICKER);

    return `${formattedStartDate} ${separator} ${formattedEndDate}`;
};
